export default "__VITE_ASSET__CxBQquHu__"